module.exports = __webpack_public_path__ + "static/media/header1.992882cb.jpg";